var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoweredby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 103.37 30.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{font-size:6.91px;fill:#bbbdbf;font-family:Montserrat-Bold, Montserrat;font-weight:700;}.cls-3{letter-spacing:-0.01em;}.cls-4{letter-spacing:-0.01em;}.cls-5{letter-spacing:-0.01em;}.cls-6{fill:#d43039;}.cls-7{clip-path:url(#clip-path);}.cls-8{fill:#d81f34;}.cls-9{fill:#272f3d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-6.91 -8.19)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 115.7,
    height: 39.13
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(30.03 5.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 5.02,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.48,
    y: 0
  }, "wered "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 34.39,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.08,
    y: 0
  }, "y:")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1.67 28.66 1.67 29.1 2.31 29.1 2.31 30.91 2.81 30.91 2.81 29.1 3.45 29.1 3.45 28.66 1.67 28.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "6.38 28.66 6.38 29.6 5.49 29.6 5.49 28.66 4.98 28.66 4.98 30.91 5.49 30.91 5.49 30.03 6.38 30.03 6.38 30.91 6.88 30.91 6.88 28.66 6.38 28.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "8.61 28.66 8.61 30.91 10.27 30.91 10.27 30.47 9.11 30.47 9.11 30 10.12 30 10.12 29.57 9.11 29.57 9.11 29.11 10.23 29.11 10.23 28.66 8.61 28.66"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M22.53,38a.72.72,0,0,0-.19-.51.64.64,0,0,0-.95,0,.72.72,0,0,0-.19.51.74.74,0,0,0,.19.52.64.64,0,0,0,.95,0,.74.74,0,0,0,.19-.52m.17.83a1.14,1.14,0,0,1-.84.33,1.17,1.17,0,0,1-.84-.33,1.18,1.18,0,0,1,0-1.66,1.17,1.17,0,0,1,.84-.33,1.14,1.14,0,0,1,.84.33,1.18,1.18,0,0,1,0,1.66",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.86,37.87A.37.37,0,0,0,26,37.6a.3.3,0,0,0-.09-.25.69.69,0,0,0-.34-.07h-.38V38h.37a.58.58,0,0,0,.35-.08m.6-.27a.67.67,0,0,1-.42.7l.57.8H26l-.5-.72h-.35v.72h-.5V36.85h.85a1.21,1.21,0,0,1,.75.18.68.68,0,0,1,.22.57",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.61,38h.51v.79a1.21,1.21,0,0,1-.93.38,1.13,1.13,0,0,1-.83-.33A1.1,1.1,0,0,1,28,38a1.14,1.14,0,0,1,.34-.84,1.16,1.16,0,0,1,.83-.33,1.24,1.24,0,0,1,.84.32l-.26.38a1.07,1.07,0,0,0-.28-.19.76.76,0,0,0-.27-.05.7.7,0,0,0-.49.2.78.78,0,0,0,0,1,.58.58,0,0,0,.45.19.83.83,0,0,0,.43-.1Z",
    transform: "translate(-6.91 -8.19)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.64,37.52l.28.65h-.57Zm-.25-.67-1,2.25H32l.21-.48h1l.21.48h.53l-1-2.25Z",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "29.95 28.66 29.95 30.11 28.84 28.66 28.37 28.66 28.37 30.91 28.87 30.91 28.87 29.5 29.95 30.91 30.45 30.91 30.45 28.66 29.95 28.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 32.17,
    y: 28.66,
    width: 0.5,
    height: 2.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "34.3 28.66 34.3 29.1 35.44 29.1 34.27 30.57 34.27 30.91 36.15 30.91 36.15 30.48 34.95 30.48 36.13 29.01 36.13 28.66 34.3 28.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.59,37.52l.28.65h-.56Zm-.24-.67-1,2.25h.54l.21-.48h.94l.21.48h.53l-1-2.25Z",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "40.97 28.66 40.97 29.1 41.61 29.1 41.61 30.91 42.11 30.91 42.11 29.1 42.75 29.1 42.75 28.66 40.97 28.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 44.29,
    y: 28.66,
    width: 0.5,
    height: 2.25
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.14,38a.72.72,0,0,0-.19-.51.64.64,0,0,0-1,0,.72.72,0,0,0-.19.51.74.74,0,0,0,.19.52.64.64,0,0,0,1,0,.74.74,0,0,0,.19-.52m.17.83a1.14,1.14,0,0,1-.84.33,1.17,1.17,0,0,1-.84-.33,1.18,1.18,0,0,1,0-1.66,1.17,1.17,0,0,1,.84-.33,1.14,1.14,0,0,1,.84.33,1.16,1.16,0,0,1,0,1.66",
    transform: "translate(-6.91 -8.19)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "51.91 28.66 51.91 30.11 50.81 28.66 50.34 28.66 50.34 30.91 50.84 30.91 50.84 29.5 51.91 30.91 52.42 30.91 52.42 28.66 51.91 28.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M62,37.52l.28.65h-.56Zm-.24-.67-1,2.25h.54l.21-.48h.94l.21.48h.54l-1-2.25Z",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "57.71 28.66 57.71 30.91 59.17 30.91 59.17 30.47 58.21 30.47 58.21 28.66 57.71 28.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "64.12 28.66 64.12 29.6 63.23 29.6 63.23 28.66 62.72 28.66 62.72 30.91 63.23 30.91 63.23 30.03 64.12 30.03 64.12 30.91 64.62 30.91 64.62 28.66 64.12 28.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "66.34 28.66 66.34 30.91 68 30.91 68 30.47 66.85 30.47 66.85 30 67.85 30 67.85 29.57 66.85 29.57 66.85 29.11 67.97 29.11 67.97 28.66 66.34 28.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.45,37.52l.28.65h-.56Zm-.24-.67-1,2.25h.53l.21-.48h.94l.21.48h.54l-1-2.25Z",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "73.19 28.66 73.19 30.91 74.65 30.91 74.65 30.47 73.69 30.47 73.69 28.66 73.19 28.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "75.8 28.66 75.8 29.1 76.44 29.1 76.44 30.91 76.94 30.91 76.94 29.1 77.58 29.1 77.58 28.66 75.8 28.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "80.51 28.66 80.51 29.6 79.61 29.6 79.61 28.66 79.11 28.66 79.11 30.91 79.61 30.91 79.61 30.03 80.51 30.03 80.51 30.91 81.01 30.91 81.01 28.66 80.51 28.66"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.84,37.94a.45.45,0,0,0,.09-.3.31.31,0,0,0-.11-.27.61.61,0,0,0-.37-.09h-.29V38h.34a.43.43,0,0,0,.34-.1m.37-.89a.77.77,0,0,1,.24.62.74.74,0,0,1-.24.61,1.2,1.2,0,0,1-.75.19h-.3v.63h-.5V36.85h.8a1.18,1.18,0,0,1,.75.2",
    transform: "translate(-6.91 -8.19)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "88.1 28.66 88.1 30.91 89.76 30.91 89.76 30.47 88.6 30.47 88.6 30 89.61 30 89.61 29.57 88.6 29.57 88.6 29.11 89.72 29.11 89.72 28.66 88.1 28.66"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100,38a.72.72,0,0,0-.19-.51.64.64,0,0,0-1,0,.72.72,0,0,0-.19.51.74.74,0,0,0,.19.52.64.64,0,0,0,1,0A.74.74,0,0,0,100,38m.17.83a1.14,1.14,0,0,1-.84.33,1.17,1.17,0,0,1-.84-.33,1.18,1.18,0,0,1,0-1.66,1.17,1.17,0,0,1,.84-.33,1.14,1.14,0,0,1,.84.33,1.18,1.18,0,0,1,0,1.66",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.26,37.94a.45.45,0,0,0,.09-.3.29.29,0,0,0-.12-.27.6.6,0,0,0-.36-.09h-.29V38h.34a.43.43,0,0,0,.34-.1m.37-.89a.77.77,0,0,1,.24.62.74.74,0,0,1-.25.61,1.17,1.17,0,0,1-.74.19h-.3v.63h-.5V36.85h.79a1.19,1.19,0,0,1,.76.2",
    transform: "translate(-6.91 -8.19)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "98.52 28.66 98.52 30.91 99.98 30.91 99.98 30.47 99.02 30.47 99.02 28.66 98.52 28.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "101.51 28.66 101.51 30.91 103.17 30.91 103.17 30.47 102.02 30.47 102.02 30 103.02 30 103.02 29.57 102.02 29.57 102.02 29.11 103.14 29.11 103.14 28.66 101.51 28.66"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M14,27.41v3.17H12.85V27.41H9.65v-1.1h3.2V23.15H14v3.16h3.2v1.1ZM13.41,22a4.87,4.87,0,1,0,4.88,4.87A4.87,4.87,0,0,0,13.41,22",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M19.62,26.86h-.29a5.91,5.91,0,1,1-1.73-4.18,5.92,5.92,0,0,1,1.73,4.18h.59a6.51,6.51,0,1,0-6.51,6.51,6.5,6.5,0,0,0,6.51-6.51Z",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.54,30.55a3,3,0,0,0,1.19-1.15,3.57,3.57,0,0,0,0-3.36,3.18,3.18,0,0,0-1.19-1.14,3.6,3.6,0,0,0-1.71-.41,3.53,3.53,0,0,0-1.7.41A3.08,3.08,0,0,0,67,26a3.5,3.5,0,0,0,0,3.36,2.9,2.9,0,0,0,1.18,1.15,3.42,3.42,0,0,0,1.7.41,3.49,3.49,0,0,0,1.71-.41m2.37-6.7v7.24a4,4,0,0,1-1,3,4,4,0,0,1-3,1,6.39,6.39,0,0,1-2.11-.34,4.13,4.13,0,0,1-1.6-.95l.42-.59a4.11,4.11,0,0,0,1.46.87,5.23,5.23,0,0,0,1.82.31,3.24,3.24,0,0,0,2.39-.77,3.2,3.2,0,0,0,.78-2.38V29.82a3.56,3.56,0,0,1-1.39,1.36,4.08,4.08,0,0,1-2,.48,4.3,4.3,0,0,1-2.06-.5,3.71,3.71,0,0,1-1.45-1.41,4.17,4.17,0,0,1,0-4.07,3.59,3.59,0,0,1,1.45-1.39,4.3,4.3,0,0,1,2.06-.5,4.17,4.17,0,0,1,2,.5,3.36,3.36,0,0,1,1.38,1.39V23.85Z",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M78.35,24.26a3.74,3.74,0,0,1,1.92-.47v.76h-.18a2.69,2.69,0,0,0-2.11.84,3.39,3.39,0,0,0-.76,2.35V32h-.78V23.85h.74v1.77a2.84,2.84,0,0,1,1.17-1.36",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87.64,30.89a3.14,3.14,0,0,0,1.16-1.21,3.88,3.88,0,0,0,0-3.55,3.14,3.14,0,0,0-1.16-1.21,3.25,3.25,0,0,0-4.51,1.21,4,4,0,0,0,0,3.55,3.33,3.33,0,0,0,4.51,1.21m-3.75.6A3.79,3.79,0,0,1,82.44,30a4.49,4.49,0,0,1,0-4.23,3.79,3.79,0,0,1,1.45-1.47,4.33,4.33,0,0,1,4.15,0,3.73,3.73,0,0,1,1.45,1.47,4.49,4.49,0,0,1,0,4.23A3.73,3.73,0,0,1,88,31.49a4.33,4.33,0,0,1-4.15,0",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M99.67,23.85V32h-.74V30.22a3,3,0,0,1-1.2,1.33,3.59,3.59,0,0,1-1.86.47,3.1,3.1,0,0,1-3.38-3.43V23.85h.77v4.68a2.85,2.85,0,0,0,.7,2.08,2.66,2.66,0,0,0,2,.71,2.82,2.82,0,0,0,2.17-.85,3.25,3.25,0,0,0,.8-2.3V23.85Z",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M107.9,30.89a3.09,3.09,0,0,0,1.17-1.21,3.88,3.88,0,0,0,0-3.55,3.09,3.09,0,0,0-1.17-1.21,3.28,3.28,0,0,0-1.68-.43,3.25,3.25,0,0,0-1.67.43,3.14,3.14,0,0,0-1.16,1.21,3.88,3.88,0,0,0,0,3.55,3.14,3.14,0,0,0,1.16,1.21,3.25,3.25,0,0,0,1.67.43,3.28,3.28,0,0,0,1.68-.43m.42-6.57a3.81,3.81,0,0,1,1.44,1.46,4.36,4.36,0,0,1,.52,2.13,4.42,4.42,0,0,1-.52,2.13,3.74,3.74,0,0,1-1.44,1.46,4,4,0,0,1-2,.52,3.77,3.77,0,0,1-1.94-.51,3.44,3.44,0,0,1-1.35-1.4V35h-.78V23.85H103v1.91a3.52,3.52,0,0,1,1.36-1.45,3.71,3.71,0,0,1,2-.52,4,4,0,0,1,2,.53",
    transform: "translate(-6.91 -8.19)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 43.72,
    y: 12.25,
    width: 1.94,
    height: 11.52
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29,31.51a2.59,2.59,0,0,1-.83.42,3.9,3.9,0,0,1-1,.14A2.92,2.92,0,0,1,25,31.35a2.73,2.73,0,0,1-.74-2.08v-4H22.87V23.73h1.37v-1.9h1.94v1.9H28.4v1.55H26.18v3.95a1.33,1.33,0,0,0,.29.92,1.12,1.12,0,0,0,.86.32,1.74,1.74,0,0,0,1.08-.34Z",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.76,30.32a1.85,1.85,0,0,0,.8-1v-1h-2c-1.12,0-1.67.37-1.67,1.1a1,1,0,0,0,.42.84,1.86,1.86,0,0,0,1.16.31,2.54,2.54,0,0,0,1.3-.33m1.77-5.87a3.43,3.43,0,0,1,1,2.65V32H35.66V31a2.2,2.2,0,0,1-1,.83,4,4,0,0,1-1.59.29,3.88,3.88,0,0,1-1.63-.32,2.46,2.46,0,0,1-1.08-.89,2.35,2.35,0,0,1,.45-3.07,4.1,4.1,0,0,1,2.61-.68h2.15V27A1.73,1.73,0,0,0,35,25.65a2.28,2.28,0,0,0-1.55-.46,4.27,4.27,0,0,0-1.37.22A3.25,3.25,0,0,0,31,26l-.77-1.41a4.69,4.69,0,0,1,1.57-.76,6.84,6.84,0,0,1,1.94-.27,4.1,4.1,0,0,1,2.81.88",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.12,29.69a2.91,2.91,0,0,0,0-3.76,2.37,2.37,0,0,0-1.76-.71,2.51,2.51,0,0,0-1.26.32,2.21,2.21,0,0,0-.88.91,2.71,2.71,0,0,0-.33,1.36,2.75,2.75,0,0,0,.33,1.37,2.33,2.33,0,0,0,.88.91,2.5,2.5,0,0,0,1.26.31,2.33,2.33,0,0,0,1.76-.71m.62-5.59a3.77,3.77,0,0,1,1.5,1.49,4.46,4.46,0,0,1,.55,2.22A4.52,4.52,0,0,1,48.24,30a3.73,3.73,0,0,1-1.5,1.5,4.4,4.4,0,0,1-2.16.53,3.94,3.94,0,0,1-1.56-.3,3.06,3.06,0,0,1-1.19-.88V32H40V20.44h1.94v4.24a3.21,3.21,0,0,1,1.17-.83,4,4,0,0,1,1.49-.28,4.4,4.4,0,0,1,2.16.53",
    transform: "translate(-6.91 -8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57.3,25.68a2.26,2.26,0,0,0-.78,1.46h4.7a2.42,2.42,0,0,0-3.92-1.46M63,28.43H56.53a2.22,2.22,0,0,0,.89,1.45,2.92,2.92,0,0,0,1.8.54,3,3,0,0,0,2.25-.9l1,1.2a3.62,3.62,0,0,1-1.41,1,5.35,5.35,0,0,1-1.93.34,5.07,5.07,0,0,1-2.41-.55A3.83,3.83,0,0,1,55.16,30a4.56,4.56,0,0,1,0-4.38,3.9,3.9,0,0,1,1.53-1.51,4.39,4.39,0,0,1,2.21-.55,4.3,4.3,0,0,1,2.16.54,3.84,3.84,0,0,1,1.49,1.5,4.57,4.57,0,0,1,.54,2.25c0,.13,0,.33,0,.57",
    transform: "translate(-6.91 -8.19)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredby);
export default __webpack_public_path__ + "static/media/poweredby.4dcb937ce1ebefb0f1137ea298486f15.svg";
export { ForwardRef as ReactComponent };